module.exports = __webpack_public_path__ + "static/media/FrX_jPkaQAA2L3O.dadad031.webp";